export default __webpack_public_path__ + "static/media/le_neubourg3.5e0544b5.jpg";